import React from 'react';
import { Marker } from 'react-leaflet';
import { tafelIcon } from '../helpers/markerHelper';
import { useData } from '../contexts/DataContext';

export default function LiveMarker() {
  const { latest } = useData();

  if (!latest) return null;

  return (
    <Marker position={[latest.lat, latest.lon]} icon={tafelIcon} />
  );
}
